import React, { useCallback } from "react";
import StyleStack from "../../../../Reuse/UI/StyleStack";
import { Divider, Stack, Typography } from "@mui/material";
import StyledButton from "../../../../Reuse/UI/StyledButton";
import ImageToCanvas from "./ImageToCanvas/ImageToCanva";
import CustomIconButton from "../../../../Reuse/UI/CustomIconButton";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import { MoveIcon, EditImageIcon } from "../../../../Reuse/Icon";
import { sortFloor, staticVar, useActiveFloorContext } from "./Constant";
import { getLabelCharacter } from "./ImageToCanvas/utils/drawUtils";
import { useDialog } from "../../../../context";

const FloorView = React.memo(
  ({ showFooter = false, droneNestClicked = null }) => {
    return (
      <React.Fragment>
        <StyleStack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
          sx={{
            flexGrow: 1,
            background: "#000000",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <FloorButtonUI />
          <FloorFooterUI showFooter={showFooter} />
          <ImageToCanvas droneNestClicked={droneNestClicked} />
        </StyleStack>
      </React.Fragment>
    );
  },
);

export default FloorView;

const FloorButtonUI = React.memo(() => {
  const { floors, activeFloor, setActiveFloor, setAction } =
    useActiveFloorContext();
  return (
    <React.Fragment>
      {floors.length && (
        <StyleStack
          direction={"column"}
          gap={1}
          sx={{
            padding: 1,
            borderRadius: 1.5,
            position: "absolute",
            top: 24,
            left: 24,
            zIndex: 1,
          }}
        >
          {floors.sort(sortFloor).map((floor) => (
            <StyledButton
              key={floor.id}
              variant={activeFloor?.id === floor.id ? "contained" : "outlined"}
              onClick={(e) => {
                e.preventDefault();
                setAction((prev) => ({
                  ...prev,
                  image: null,
                  showOnMap: null,
                  isCenter: true,
                  scale: 1,
                }));
                setActiveFloor(floor);
              }}
              fullWidth
            >
              <Typography variant="">{floor?.label || ""}</Typography>
            </StyledButton>
          ))}
        </StyleStack>
      )}
    </React.Fragment>
  );
});

const FloorFooterUI = React.memo(({ showFooter }) => {
  const { activeFloorDroneNest, action, setAction } = useActiveFloorContext();
  const { showInfo } = useDialog();

  const zoomIn = useCallback(() => {
    setAction((prev) => ({
      ...prev,
      scale: Math.min(prev.scale + 0.25, 5),
    })); // max 5x zoom
  }, [setAction]);

  const zoomOut = useCallback(() => {
    setAction((prev) => ({
      ...prev,
      scale: Math.max(prev.scale - 0.25, 0.25),
    })); // min 0.25x zoom
  }, [setAction]);

  const setType = useCallback(
    (status) => {
      if (status !== "move") {
        if (action.isDirty) {
          showInfo(staticVar.info);
          return;
        }
      }
      setAction((prev) => ({
        ...prev,
        type: prev.type === status ? null : status,
      }));
    },
    [setAction, action],
  );
  return (
    <React.Fragment>
      <StyleStack
        direction={"row"}
        gap={1}
        sx={{
          padding: 1,
          borderRadius: 1.5,
          position: "absolute",
          bottom: 12,
          margi: "auto",
          zIndex: 1,
        }}
      >
        {/* {showFooter && (
          <>
            <StyledButton
              variant={action.type === "edit" ? "contained" : "outlined"}
              startIcon={<EditImageIcon sx={{}} />}
              onClick={() => setType("edit")}
            >
              <Typography variant="h5">Edit</Typography>
            </StyledButton>
            <Divider orientation="vertical" flexItem />
          </>
        )} */}

        <StyledButton
          variant={action.type === "move" ? "contained" : "outlined"}
          startIcon={<MoveIcon sx={{}} />}
          onClick={() => setType("move")}
        >
          <Typography variant="h5">Move</Typography>
        </StyledButton>
        {showFooter && (
          <React.Fragment>
            <Divider orientation="vertical" flexItem />
            <StyledButton
              variant="contained"
              startIcon={
                <Stack
                  sx={{
                    borderRadius: 0.5,
                    background: "#144FE1",
                    border: "1.5px solid #ffffff",
                    minWidth: 20,
                    height: 20,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 15,
                      fontWeight: 700,
                      lineHeight: "100%",
                    }}
                  >
                    {getLabelCharacter(activeFloorDroneNest.length)}
                  </Typography>
                </Stack>
              }
              onClick={() => setType("add")}
            >
              <Typography variant="h5">Drone Box</Typography>
              {/* <Stack direction={"row"} gap={1} alignItems={"center"}>
            <Chip label="A" color="primary" />
          </Stack> */}
            </StyledButton>
          </React.Fragment>
        )}
        <Divider orientation="vertical" flexItem />
        <Stack direction={"row"} gap={1} alignItems={"center"}>
          <CustomIconButton onClick={zoomIn}>
            <AddRoundedIcon />
          </CustomIconButton>
          <Typography variant="h6">{action.scale * 100}%</Typography>
          <CustomIconButton onClick={zoomOut}>
            <RemoveRoundedIcon />
          </CustomIconButton>
        </Stack>
      </StyleStack>
    </React.Fragment>
  );
});
